import { useCallback, useEffect, useState } from 'react';

import { report } from 'root/apps/NetworkHealthTool/services/NetworkHealthToolReportingService';
import { useNetworkTestService } from 'root/apps/NetworkHealthTool/services/useNetworkHealthToolService';
import { NetworkEventType } from 'root/apps/NetworkHealthTool/utils/channelUtils';
import { logError } from 'root/datadog/datadogLogs';

export const useSyncNetworkTestReports = () => {
  const service = useNetworkTestService();
  const [isSyncing, setIsSyncing] = useState(false);

  const runSyncReport = useCallback(async () => {
    if (isSyncing) return;
    setIsSyncing(true);

    try {
      const unsyncedReports = await service.getAllUnsyncedNetworkTests();

      if (!unsyncedReports || unsyncedReports.length === 0) {
        setIsSyncing(false);
        return;
      }

      await unsyncedReports.reduce(
        (promise, reportItem) => promise.then(() => report(reportItem.scores, reportItem, service)),
        Promise.resolve()
      );
    } catch (error) {
      logError(error, {
        message: 'useSyncNetworkTestReports.runSyncReport failed',
        source: 'NetworkHealthTool',
        file: 'useNetworkHealthToolReportingService.ts',
      });
    } finally {
      setIsSyncing(false);
    }
  }, [service, isSyncing]);

  useEffect(() => {
    if (service) {
      service.on(NetworkEventType.NETWORK_TEST_UPDATED, runSyncReport);
      return () => {
        service.off(NetworkEventType.NETWORK_TEST_UPDATED, runSyncReport);
      };
    }
    return undefined;
  }, [service, runSyncReport]);
};
